import { render, staticRenderFns } from "./PenilaianSoalEssay.vue?vue&type=template&id=0f4c841e&scoped=true"
import script from "./PenilaianSoalEssay.vue?vue&type=script&lang=js"
export * from "./PenilaianSoalEssay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c841e",
  null
  
)

export default component.exports